var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg959699Thunderstorm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 430.9 370.1",
    style: {
      enableBackground: "new 0 0 430.9 370.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;}\r\n\t.st2{fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.1,5.5c-50.7,0-92.8,38.9-97,89.1l-0.4,5.1h-11c-34.9,0-63.2,28.3-63.2,63.2s28.3,63.2,63.2,63.2H287 c42.2,0,76.5-34.2,76.5-76.5S329.3,73.1,287,73.1c-4,0-8,0.3-11.9,0.9l-4.5,0.7l-1.5-4.3C255.3,31.8,218.7,5.5,177.1,5.5L177.1,5.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.6,62.1l-15.3,6.6c-13.6-31.4-44.5-52.1-79.3-52.1c-44.9,0-82.3,34.5-86,79l-1.3,15.2H68.5 c-28.8,0-52.1,23.3-52.1,52.1S39.7,215,68.5,215h128.7v16.6H68.7C30.8,231.6,0,200.8,0,162.9s30.8-68.7,68.7-68.7h5.9 C79,41.4,123.3,0,177.2,0C219.5,0,255.8,25.5,271.6,62.1L271.6,62.1z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(199 190)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.9-128c-38,0-69.5,29.9-72.7,68.5l-0.3,3.9H5.7c-26.2,0-47.4,21.8-47.4,48.6s20.4,48.6,46.5,48.6h164 c31.6,0,57.6-26.3,57.6-58.8S200.8-76,169.1-76c-3,0-6,0.2-8.9,0.7l-3.4,0.5l-1.1-3.3C145.5-107.8,118.1-128,86.9-128z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.4,41.6V25H169c25.7,0,46.4-20.7,46.4-46.2S194.6-67.4,169-67.4c-2.5,0-4.9,0.2-7.3,0.6l-13.6,2.1l-4.6-13 c-8.7-24.6-32.2-41.5-59-41.5c-32.6,0-59.6,24.9-62.3,56.9l-1.3,15.2H1.2c-20,0-36.2,16.1-36.2,36s16.2,36,36.2,36h4.9v16.6H1.2 C-28,41.5-51.6,18-51.6-11.1c-0.1-29,23.6-52.5,52.8-52.5h4.5c3.4-40.4,37.4-72.1,78.8-72.1c34.4,0,63.7,21.9,74.6,52.5 c3.3-0.5,6.5-0.8,9.8-0.8c34.8,0,63,28.1,63,62.8s-28.2,62.8-63,62.8H156.4L156.4,41.6z M156.4,41.6V25H169 c25.7,0,46.4-20.7,46.4-46.2S194.6-67.4,169-67.4c-2.5,0-4.9,0.2-7.3,0.6l-13.6,2.1l-4.6-13c-8.7-24.6-32.2-41.5-59-41.5 c-32.6,0-59.6,24.9-62.3,56.9l-1.3,15.2H1.2c-20,0-36.2,16.1-36.2,36s16.2,36,36.2,36h4.9v16.6H1.2C-28,41.5-51.6,18-51.6-11.1 c-0.1-29,23.6-52.5,52.8-52.5h4.5c3.4-40.4,37.4-72.1,78.8-72.1c34.4,0,63.7,21.9,74.6,52.5c3.3-0.5,6.5-0.8,9.8-0.8 c34.8,0,63,28.1,63,62.8s-28.2,62.8-63,62.8H156.4L156.4,41.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 6.5,
    cy: 33.3,
    r: 8.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 156.1,
    cy: 33.3,
    r: 8.3
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M255.9,117.4l-32.1,114.1h55.4l-31,138.5l108.6-180.6h-58.7l32.1-72H255.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.1,128.5h-48.8l-25.9,92H293l-19.1,85.2l63.2-105.2h-56.2L313.1,128.5z M279.2,231.6h-55.4l32.1-114.2h74.3l-32.1,72 h58.7L248.2,370.1L279.2,231.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg959699Thunderstorm);
export default __webpack_public_path__ + "static/media/95_96_99_thunderstorm.bfb0fe3b5666fc928dd3df5527c0c402.svg";
export { ForwardRef as ReactComponent };